import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


// This class exists because this functionality cannot be inside the user.service class. The reason is that user.service requires http but the interceptor requires both http and the
// the functionality in this class so there would be a cyclical dependency. Here we set the login status as a service accessible from both user service and the http interceptor without any other dependencies

@Injectable({ providedIn: 'root' })
export class LoginStatus {

    private _authNavStatusSource = new BehaviorSubject<boolean>(false);

    loggedIn = this._authNavStatusSource.asObservable();

    constructor() {
        const loggedIn = !!sessionStorage.getItem('accessToken');
        this._authNavStatusSource.next(loggedIn);
    }


    setStatus(status: boolean) {
        this._authNavStatusSource.next(status);
    }

    logout() {
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('billingSnackbarShown');
        sessionStorage.removeItem('envId');
        sessionStorage.removeItem('envName');
        sessionStorage.removeItem('firstName');
        sessionStorage.removeItem('lastName');
        sessionStorage.removeItem('locale');
        sessionStorage.removeItem('orgId');
        sessionStorage.removeItem('orgName');
        sessionStorage.removeItem('orgStackURL');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('orgStackAPIKey');
        this.setStatus(false);
    }
}

